import { ISearchBox, SearchBox, Stack } from "@fluentui/react";
import React, { KeyboardEventHandler } from "react";
import HeaderTable from "../generic/HeaderTable";

interface ICabeceraTable {
  Titulo: string;
  SubTitulo: string;
  componentRef?: React.Ref<ISearchBox>;
  onKeyUp?: KeyboardEventHandler<HTMLInputElement> | undefined;
  placeholder?: string;
}

export const CabeceraTable = (props: ICabeceraTable) => {
  return (
    <>
      <Stack horizontal padding={5} style={{ width: "100%" }}>
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4">
          <HeaderTable
            title={props.Titulo}
            subTitle={props.SubTitulo}
            hidenIcon={true}
          />
        </div>
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col  ms-lg11">
              {props.placeholder && (
                <SearchBox
                  // underlined
                  componentRef={props.componentRef}
                  placeholder={props.placeholder}
                  onKeyUp={props.onKeyUp}
                  // defaultValue={props.value === null ? "" : props.value}
                  // onSearch={searchHandler}
                  // onChange={searchChange}
                  // value={props.searchValue == null ? "" : props.searchValue}
                  // autoComplete="off"
                  // onClear={onClearHandler}
                />
              )}
            </div>
          </div>
        </div>
      </Stack>
    </>
  );
};
